import React, { useEffect, useState } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { enablePush, disablePush, getPushPermission, pushSupported } from '@/lib/push';

export const EnablePush = () => {
  const [perm, setPerm] = useState('default');
  const [busy, setBusy] = useState(false);

  useEffect(() => { setPerm(getPushPermission()); }, []);

  if (!pushSupported() || perm === 'unsupported') return null;

  const onClick = async () => {
    setBusy(true);
    try {
      if (perm === 'granted') {
        await disablePush();
        setPerm('default');
        toast.success('Push notifications turned off');
      } else {
        await enablePush();
        setPerm('granted');
        toast.success('Push notifications enabled');
      }
    } catch (e) {
      toast.error(e.message || 'Could not toggle notifications');
      setPerm(getPushPermission());
    } finally {
      setBusy(false);
    }
  };

  const active = perm === 'granted';
  const Icon = active ? Bell : BellOff;
  return (
    <button
      onClick={onClick}
      disabled={busy}
      data-testid="enable-push-btn"
      title={active ? 'Disable push notifications' : 'Enable push notifications'}
      className={`bz-btn-ghost !p-2 ${active ? 'text-[#1E3A8A]' : ''}`}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
};

export default EnablePush;
